module.exports = __webpack_public_path__ + "img/swiper5.985dc9f3.png";